export default "__VITE_ASSET__f2942e9f__"